import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface TopLevelBucketIdFormFieldProps {
  topLevelBuckets?: { label: string; value: number }[]
  loading?: boolean
}

export const TopLevelBucketIdFormField: React.FC<TopLevelBucketIdFormFieldProps> = ({
  topLevelBuckets,
  loading,
}) => {
  const { control, setValue } = useFormContext<{ top_level_bucket_id: number | null }>()

  return (
    <FormField
      name="top_level_bucket_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Top Level Bucket</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              placeholder={'Select a Top Level Bucket'}
              value={field.value?.toString()}
              loading={loading}
              setValue={(val) =>
                setValue('top_level_bucket_id', val ? parseInt(val) : null, {
                  shouldValidate: true,
                })
              }
              options={topLevelBuckets?.map(({ label, value }) => ({
                label,
                value: value?.toString(),
              }))}
            />
          </FormItem>
        )
      }}
    />
  )
}
